export default __webpack_public_path__ + "static/media/Sepp-auf-Wiese-mit-Musik.2d4794a2.webp";